import React from "react";
import {useParams} from "react-router-dom"
import {Link } from "react-router-dom"
import {faArrowCircleLeft} from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./image.css"

function Image(){
    const { id } = useParams();
    const { backPage } = useParams();
    return(
        <div className="image_content_div float-start w-100">
            <div className="image_content_div_marge image_content_div_marge_resp" >
                <div className="w-100 float-start mt-3 text-sm-start"><Link className="text-decoration-none fw-bold imageBackLink" to={"/" + backPage } ><FontAwesomeIcon icon={faArrowCircleLeft} /> Retour</Link></div>
                <img className="mx-auto m-4 w-100" src={"/data/appData/appImages/pedigree/"+id+".png"}  alt="full pedegree" onContextMenu={(e)=> e.preventDefault()} />
            </div>
        </div>
    )

}
export default Image